import findIndex from 'lodash/findIndex';
import isNumber from 'lodash/isNumber';
import React from 'react';


export class ModalStack {
  constructor() {
    this.stack = [];
  }

  add(modal) {
    this.stack = [...this.stack, modal];
  }

  remove(key) {
    const index = findIndex(this.stack, {key});
    if (index > -1 && index < this.stack.length) {
      this.stack = [
        ...this.stack.slice(0, index),
        ...this.stack.slice(index + 1),
      ];
    }
  }

  clear() {
    this.stack = [];
  }

  /**
   * @param {Object|Number} modal Either the modal Object or the key
   * @return {boolean}
   */
  isHighest(modal) {
    const index = isNumber(modal) ? findIndex(this.stack, {key: modal}) : this.stack.indexOf(modal);
    return (index > -1 && index === this.stack.length - 1);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-modals/ModalStack.js